// src/utils/urlStateManager.js
// ============================================
// Only storeNameToSlug is still used across the app.
// All other URL/session state management has been moved
// to OrderFlowContext and sessionStorage helpers.
// ============================================

/**
 * Convert a store name to a URL-safe slug.
 * e.g. "Royal Spice (Main)" → "royal-spice-main"
 */
export const storeNameToSlug = (name) => {
  if (!name) return null;
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};